module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5wvf8"))).then(() => parcelRequire('2KbAe'));